import { render, staticRenderFns } from "./TinyMCE.vue?vue&type=template&id=bece3d5c"
import script from "./TinyMCE.vue?vue&type=script&lang=js"
export * from "./TinyMCE.vue?vue&type=script&lang=js"
import style0 from "./TinyMCE.vue?vue&type=style&index=0&id=bece3d5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../microservices/playlist/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports